import { Caption } from '@/components';
import React from 'react';
import * as styles from './index.module.less';

export enum NewsType {
  INFO = 'info',
  MEDIA = 'media',
  RELEASE = 'release',
}

const TAG_LIST = {
  [NewsType.INFO]: {
    bg: '#D6EFFF',
    fontColor: '#3089F0',
    text: 'お知らせ',
  },
  [NewsType.MEDIA]: {
    bg: '#FFF0D6',
    fontColor: '#F59230',
    text: 'メディア掲載',
  },
  [NewsType.RELEASE]: {
    bg: '#D6FFEB',
    fontColor: '#2AD194',
    text: '機能リリース',
  },
};

interface IProp {
  tagType: NewsType;
}

const NewsTag = ({ tagType }: IProp) => {
  const CUR_TAG = TAG_LIST[tagType];
  return (
    <div
      className={styles.tag_container}
      style={{
        background: CUR_TAG?.bg,
        color: CUR_TAG?.fontColor,
      }}
    >
      <Caption>{CUR_TAG?.text}</Caption>
    </div>
  );
};
export default NewsTag;
